<template>
  <div class="rightContent">
    <el-table stripe :data="tableData"
      @sort-change="sortChange" border style="width: 100%" height="100%" size="mini">
      <el-table-column type="index" :width="50" align="center"></el-table-column>
      <el-table-column prop="version" sortable="custom"
        label="版本号" min-width="140px" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.version">{{ scope.row.version }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="file" min-width="160px"
        label="文件名" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.file && scope.row.file.fileName" class="allowSkip"
            @click="downloadIq(scope.row)">
            {{ scope.row.file.fileName }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="iqMd5" min-width="180px"
        label="文件MD5" align="left" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.iqMd5">{{ scope.row.iqMd5 }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" sortable="custom" prop="enable"
        label="状态" align="center" width="130px">
        <template slot-scope="scope">
          <span v-if="scope.row.enable">已启用</span>
          <span v-else style="color: #F56C6C">已禁用</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation"
        label="操作" align="center" width="180px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="下载" placement="top" :open-delay="300">
            <i v-if="scope.row.file" @click="downloadIq(scope.row)" class="iconfont icon-xiazai"></i>
          </el-tooltip>
          <el-tooltip v-if="scope.row.enable" class="item" effect="dark"
            content="禁用" placement="top" :open-delay="300">
            <i @click="disableIq($event, scope.row)" class="iconfont icon-jinyong"></i>
          </el-tooltip>
          <el-tooltip v-else class="item" effect="dark"
            content="启用" placement="top" :open-delay="300">
            <i @click="enableIq($event, scope.row)" class="iconfont icon-qiyong"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <myDialog ref="myDialog" :title="dialogTitle" :width="winWidth"
      @submitData="saveForm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form ref="addForm" :model="addForm"
          :rules="dialogRules" :label-width="labelWidth">
          <el-form-item label="版本号" size="small" prop="version" class="inlineItem">
            <el-input v-model="addForm.version"
              placeholder="如：V1.0.1" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="IQ文件" size="small" prop="file" class="inlineItem">
            <input type="file" ref="iqFile" accept=".jffs2" @change="fileChange"/>
            <span v-if="isEdit && addForm.originalName" style="margin-left:6px;color:#909399;">
              当前文件：{{ addForm.originalName }}
            </span>
          </el-form-item>
          <el-form-item label="MD5" size="small" prop="iqMd5">
            <el-input v-model="addForm.iqMd5" clearable
              maxlength="256" placeholder="IQ文件的MD5"></el-input>
          </el-form-item>
          <el-form-item label="备注" size="small" prop="notes">
            <el-input v-model="addForm.notes" type="textarea" :rows="3"
              maxlength="255" show-word-limit placeholder="备注说明"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import myDialog from "@/components/myDialog.vue";
import {
  apiProductIqAdd,
  apiProductIqUpdate,
  apiProductIqDelete,
  apiProductIqEnable,
  apiProductIqDisable,
  apiProductIqSearch
} from "@/api/ProductIq.js";
import { apiUploadFile, apiDownloadFile } from "@/api/filesUpload.js";
export default {
  components: {
    myDialog
  },
  props: {
    tabPaneValue: {
      type: String,
    }
  },
  data() {
    return {
      orderBy: [],
      desc: undefined,
      addForm: {},
      winWidth: "680px",
      tableData: [],
      labelWidth: this.$store.state.labelWidth,
      dialogTitle: "",
      isEdit: false,
      dialogRules: {
        version: [
          { required: true, message: "版本号不能为空！", trigger: "blur" },
        ],
        file: [
          { required: true, message: "IQ文件不能为空！", trigger: "blur" },
        ],
        iqMd5: [
          { required: true, message: "MD5不能为空！", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.loadData();
    },
    addIq() {
      this.addForm = {};
      this.isEdit = false;
      this.dialogTitle = "新增IQ";
      if (this.$refs.iqFile) {
        this.$refs.iqFile.value = "";
      }
      this.$refs.myDialog.dialogVisible = true;
    },
    editIq(e, row) {
      this.addForm = {
        id: row.id,
        version: row.version,
        notes: row.notes,
        archiveId: row.archiveId,
        iqMd5: row.iqMd5,
        originalName: row.file ? row.file.fileName : "",
      };
      this.isEdit = true;
      this.dialogTitle = "修改IQ";
      if (this.$refs.iqFile) {
        this.$refs.iqFile.value = "";
      }
      this.$refs.myDialog.dialogVisible = true;
    },
    // 选择IQ文件
    fileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (file) {
        this.$set(this.addForm, "file", file);
      } else {
        this.$delete(this.addForm, "file");
      }
    },
    // 下载IQ文件
    downloadIq(row) {
      if (row.file && row.file.fid) {
        window.open(apiDownloadFile(row.file.fid));
      }
    },
    enableIq(e, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: `启用IQ`,
        message: h("div", null, [
          h("span", null, `请输入版本号:【`),
          h("i", { style: "color: var(--themeColor)" }, row.version),
          h("span", null, `】以便确认启用`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.version) {
              done();
            } else {
              this.$message({ type: "warning", message: `输入错误，请重新输入或取消！` });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        let res = await apiProductIqEnable({ id: row.id });
        if (res.code == 0) {
          this.$message({ message: res.msg, type: "success" });
          this.loadData();
        }
      });
    },
    disableIq(e, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: `禁用IQ`,
        message: h("div", null, [
          h("span", null, `请输入版本号:【`),
          h("i", { style: "color: var(--themeColor)" }, row.version),
          h("span", null, `】以便确认禁用`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.version) {
              done();
            } else {
              this.$message({ type: "warning", message: `输入错误，请重新输入或取消！` });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        let res = await apiProductIqDisable({ id: row.id });
        if (res.code == 0) {
          this.$message({ message: res.msg, type: "success" });
          this.loadData();
        }
      });
    },
    deleteIq(e, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: `删除IQ`,
        message: h("div", null, [
          h("span", null, `请输入版本号:【`),
          h("i", { style: "color: var(--themeColor)" }, row.version),
          h("span", null, `】以便确认删除`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.version) {
              done();
            } else {
              this.$message({ type: "warning", message: `输入错误，请重新输入或取消！` });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        let res = await apiProductIqDelete({ id: row.id });
        if (res.code == 0) {
          this.$message({ message: res.msg, type: "success" });
          this.loadData();
        }
      });
    },
    dialogClose() {
      this.addForm = {};
      if (this.$refs.iqFile) {
        this.$refs.iqFile.value = "";
      }
    },
    async loadData() {
      const res = await apiProductIqSearch({
        productId: this.tabPaneValue,
        orderBy: this.orderBy,
        desc: this.desc,
      });
      if (res.code == 0) {
        this.tableData = res.data;
      }
    },
    async saveForm() {
      this.$refs.addForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        // 确定最终的 archiveId：选择新文件则先上传
        let archiveId = this.addForm.archiveId || 0;
        if (this.addForm.file) {
          let fd = new FormData();
          fd.append("file", this.addForm.file);
          const uploadRes = await apiUploadFile(fd);
          if (uploadRes.code != 0) {
            this.$message({ type: "error", message: uploadRes.msg || "上传失败！" });
            return false;
          }
          archiveId = uploadRes.fid;
        }
        if (archiveId <= 0) {
          this.$message({ type: "warning", message: "请选择IQ文件！" });
          return false;
        }
        const payload = {
          productId: this.tabPaneValue,
          archiveId: archiveId,
          version: this.addForm.version,
          notes: this.addForm.notes,
          iqMd5: this.addForm.iqMd5,
        };
        let res;
        if (this.dialogTitle == "修改IQ") {
          payload.id = this.addForm.id;
          res = await apiProductIqUpdate(payload);
        } else if (this.dialogTitle == "新增IQ") {
          res = await apiProductIqAdd(payload);
        } else {
          this.$message({ message: '不支持的操作【' + this.dialogTitle + '】', type: "error" });
          return false;
        }
        if (res.code == 0) {
          this.$refs.myDialog.dialogVisible = false;
          this.$message({ message: res.msg, type: "success" });
          this.loadData();
        }
      });
    }
  }
};
</script>
<style scoped>
</style>
